import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
    selector: 'app-viewer-coordinate-controls',
    templateUrl: './viewer-coordinate-controls.component.html',
    styleUrls: ['./viewer-coordinate-controls.component.scss'],
})
export class ViewerCoordinateControlsComponent {
    @Input() position = new Float32Array()
    @Output() setPosition = new EventEmitter<Float32Array>()
    @Output() centerPosition = new EventEmitter<void>()

    onCoordinateChanged(coordinateIdx: number, event: Event): void {
        const value = parseFloat((event.target as HTMLInputElement).value)
        if (isNaN(value)) {
            return
        }
        const position = new Float32Array(this.position)
        // TODO: rethink this fix of 0.5 dimension offset, should probably be on all axes, see e.g. position_widget.ts line 328 or 390 and following
        if (coordinateIdx == 2) position[coordinateIdx] = value + 0.5
        else position[coordinateIdx] = value

        this.setPosition.emit(position)
    }

    center(): void {
        this.centerPosition.emit()
    }

    copyValues(): string {
        return (
            this.position[0].toFixed(1) +
            ',' +
            this.position[1].toFixed(1) +
            ',' +
            this.position[2].toFixed(1)
        )
    }

    handleDropEvent(event: ClipboardEvent): void {
        event.preventDefault()
        const clipBoardData = event.clipboardData?.getData('text').split(',')
        if (clipBoardData && clipBoardData.length === 3) {
            clipBoardData.forEach((v, i) => {
                this.setPosition.emit(new Float32Array(parseFloat(v)))
                this.position[i] = parseFloat(v)
            })
        }
    }

    onEnter(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            const inputElement = event.target as HTMLInputElement
            inputElement.blur()
        }
    }
}
